module.exports = __webpack_public_path__ + "static/media/helpcard1.565d9553.svg";